const FIELD_KEYS = [
  'firstName',
  'lastName',
  'phoneNumber',
  'nationality',
  'currentLocation',
  'address',
];

function hasText(value) {
  return Boolean(String(value ?? '').trim());
}

function getDefaultAddress(addresses = []) {
  if (!Array.isArray(addresses) || addresses.length === 0) return null;
  return addresses.find((a) => a.isDefault) || addresses[0];
}

/** Location is satisfied by profile field or a saved shipping address. */
export function hasCurrentLocation(user, addresses = []) {
  if (hasText(user?.currentLocation)) return true;
  const addr = getDefaultAddress(addresses);
  if (!addr) return false;
  return (
    hasText(addr.city) ||
    hasText(addr.neighborhood) ||
    hasText(addr.state) ||
    hasText(addr.country)
  );
}

export function getDisplayCurrentLocation(user, addresses = []) {
  if (hasText(user?.currentLocation)) return user.currentLocation;
  const addr = getDefaultAddress(addresses);
  if (!addr) return '';
  return [addr.city, addr.neighborhood, addr.state, addr.country]
    .filter(Boolean)
    .join(', ');
}

export function getProfileCompletion(user, addresses = []) {
  const missing = [];

  if (!hasText(user?.firstName)) missing.push('firstName');
  if (!hasText(user?.lastName)) missing.push('lastName');
  if (!hasText(user?.phoneNumber || user?.phone)) missing.push('phoneNumber');
  if (!hasText(user?.nationality)) missing.push('nationality');
  if (!hasCurrentLocation(user, addresses)) missing.push('currentLocation');
  if (!Array.isArray(addresses) || addresses.length === 0) missing.push('address');

  const total = FIELD_KEYS.length;
  return {
    isComplete: missing.length === 0,
    missing,
    percent: Math.round(((total - missing.length) / total) * 100),
  };
}

export function getMissingFieldLabelKey(field) {
  const map = {
    firstName: 'profileCompletion.missingFirstName',
    lastName: 'profileCompletion.missingLastName',
    phoneNumber: 'profileCompletion.missingPhone',
    nationality: 'profileCompletion.missingNationality',
    currentLocation: 'profileCompletion.missingLocation',
    address: 'profileCompletion.missingAddress',
  };
  return map[field] || field;
}

export function getProfileTabForMissingField(field) {
  if (field === 'address' || field === 'currentLocation') return 'addresses';
  return 'settings';
}
